<template>
  <div>
    <Header>Event List</Header>
    <div class="tiled-bar-image"></div>
    <Main>
      <div class="mt-3 text-left p-3 bg-gray-100 rounded-md !shadow">
        <SearchForm
          v-model="search.query"
          @clear="clearAllFilters"/>
          <div class="flex flex-row justify-between">
            <div class="flex gap-4 flex-wrap pb-3">
              <div class="flex flex-row">
                <div class="rounded-l-md shadow-sm p-2">
                  Start
                </div>
                <Input
                  label="Start"
                  ref="startDateInput"
                  class="rounded-md shadow-sm"
                  type="date"
                  v-model="startDate"
                />
              </div>
              <div class="flex flex-row">
                <div class="rounded-l-md shadow-sm p-2">
                  End
                </div>
                <Input
                  label="End"
                  ref="endDateInput"
                  class="rounded-md shadow-sm"
                  type="date"
                  v-model="endDate"
                />
              </div>
              <div class="flex flex-row">
                <Button
                  class="bg-white rounded-md text-gray-600 font-normal shadow-sm h-10 p-2 hover:!bg-gray-50"
                  :size="'sm'"
                  @click="clearDateRange()">
                  Clear
                </Button>
              </div>
            </div>
            <div class="flex flex-row items-center gap-2">
              <div v-if="canSubmitNew" class="flex flex-row items-center h-10 bg-white rounded-md shadow-sm">
                <label class="cursor-pointer text-gray-600 font-normal h-10 px-3 flex items-center justify-center rounded-l-md mb-0">
                  <span>Choose CSV</span>
                  <input
                    ref="bulkImportInput"
                    type="file"
                    accept=".csv"
                    style="display: none;"
                    @change="onBulkImportFileSelected"
                  />
                </label>
                <span class="flex items-center h-10 px-2 text-gray-500 text-sm truncate max-w-[10rem]">{{ bulkImportFile?.name || 'No file chosen' }}</span>
                <Button
                  :color="bulkImportFile ? 'blue' : 'gray'"
                  :size="'sm'"
                  class="rounded-r-md h-10 flex items-center"
                  :disabled="!bulkImportFile || bulkImportSubmitting"
                  @click="submitBulkImport()">
                  Import CSV
                </Button>
              </div>
              <a ref="download">
                <Button
                  class="bg-white rounded-md text-gray-600 font-normal shadow-sm h-10 p-2 hover:!bg-gray-50"
                  :size="'sm'"
                  @click="exportToCSV()">
                  Export to CSV
                </Button>
              </a>
            </div>
          </div>
        <div class="flex gap-4 flex-wrap justify-between">
          <div class="flex gap-4 flex-wrap items-end">
            <FilterSelector
              v-for="(filterObj, index) in filterUis"
              :key="index"
              :name="filterObj.name"
              :text="filterObj.text"
              :selectedFilter="selectedFilter[filterObj.name]"
              @setSelectedFilter="setSelectedFilter(filterObj.name, $event)"
              :filterOptions="filterOptions[filterObj.name]"
              :optionDisplay="filterObj.option.display">
              <template #text>
                {{ filterObj.text }}
              </template>
              <template #options>
                <option
                  v-for="(filterOption, index) in filterOptions[filterObj.name]"
                  :key="index"
                  :value="filterOption[filterObj.option.value]">
                  {{ filterOption[filterObj.option.display] }}
                </option>
              </template>
            </FilterSelector>
            <label class="flex items-center gap-1 mb-2">
              <input type="checkbox"
                v-model="showPastEvents">
              Show past events
            </label>
          </div>
          <div class="flex items-center">
            <Button v-if="canSubmitNew"
              :color="'blue'"
              :size="'sm'"
              class="rounded-md !shadow m-1 h-9"
              @click="toCalendarForm()">
              New event
            </Button>
          </div>
        </div>
      </div>
      <div class="mt-6 space-y-2 pb-6">
        <div class="flex justify-center">
          <Pagination :pages="pages" to="/EventList" />
        </div>
        <TableComponent>
          <template #columns>
            <th
              v-for="field in fields"
              :key="field.key">
              <SortTable
                v-if="field.sortable"
                :name="field.key"
                :selectedSort="selectedSort"
                @setSelectedSort="selectedSort = $event">
                {{ field.label }}
              </SortTable>
              <div v-else class="px-2 py-2">
                {{ field.label }}
              </div>
            </th>
          </template>
          <template #rows v-if="!loading">
            <EventListItem
              v-for="(event, index) in calEventList"
              :key="index"
              :index="index"
              :event=event
              @onEdit="onEdit(event)"
              @onDelete="onDelete(event)"
              :selected="event.id == selected"
              @changeSelected="selected = $event"
              >
            </EventListItem>
          </template>
        </TableComponent>
        <Spinner
          v-if="loading"
          message="Loading Events"
          :size="10"
        />
        <div class="flex justify-center">
          <Pagination :pages="pages" to="/EventList" />
        </div>
      </div>
    </Main>
    <Modal
      ref="delete-modal"
      size="sm"
      anchor="centered"
      :showClose="true"
      :onSuccess="() => deleteItem(calEventList.find(el => el.id === deleteId)?.id)"
    >
      <template #title>Delete this event?</template>
      <template #content>
        <table>
          <tr>
            <th>District</th>
            <th>Date</th>
            <th>Event Type</th>
          </tr>
          <tr>
            <td>{{ calEventList.find(el => el.id === deleteId)?.district?.label }}</td>
            <td>{{ calEventList.find(el => el.id === deleteId)?.event_date }}</td>
            <td>{{ typeFormatter(calEventList.find(el => el.id === deleteId)?.event_type) }}</td>
          </tr>
        </table>
        <!-- <div class="flex flex-col">
          <div>
            From district: {{ calEventList.find(el => el.id === deleteId).district.label }}
          </div>
          <div>
            For date: {{ calEventList.find(el => el.id === deleteId).event_date }}
          </div>
        </div> -->
      </template>
      <template #footer="slotProps">
        <button
          type="button"
          class="rounded-md font-medium text-red-900 bg-red-200 px-3 py-2 hover:bg-red-300 transition-colors shadow-sm"
          @click="() => slotProps.closeModal(true)"
        >
          Delete
        </button>
      </template>
    </Modal>
  </div>
</template>

<style scoped>
.tiled-bar-image {
  width: 100%;
  height: 25px;
  background-image: url("@/assets/Bar.png");
  background-repeat: repeat-x;
}
</style>

<script>
import Header from '../../components/Header.vue'
import Main from '../../components/Main.vue'
import SearchForm from '../../components/Search/SearchForm.vue'
import Table from '../../components/Table.vue'
import SortTable from '../../components/SortTable.vue'
import Spinner from '../../components/Spinner.vue'
import Modal from '../../components/Modal.vue'
import DropdownLists from '../../components/DropdownLists.json'
import Button from '../../components/Button.vue'
import Input from '../../components/Input.vue'
import Pagination from '../../components/Pagination.vue'
import FilterSelector from '../../components/FilterSelector.vue'

import EventListItem from './EventListItem.vue'
import FieldsDef from './FieldsDef.js'

import user from '../../services/user/user.js'
// import view from '../../services/user/view.js'
import events from '../../services/events.js'

import eventListService from '../../services/pages/eventList.js'
import calendarFormService from '../../services/formSubmission/calendarForm.js'

import { isEmpty } from 'lodash'

const ORDER_BY_KEY_MAP = {
  event_date: 'eventDate',
  event_type: 'eventType',
  district: 'district',
  building: 'building',
  notes: 'notes',
  created_at: 'createdAt',
}

const SEARCH_DEBOUNCE_MS = 300

function createFilterQueryParam(selectedFilter) {
  let filterQueryParam = ''
  for (const [key, selected] of Object.entries(selectedFilter)) {
    if (!isEmpty(selected)) {
      if (filterQueryParam) {
        filterQueryParam += ';'
      }
      filterQueryParam += `${key}=${selected.join(',')}`
    }
  }
  if (filterQueryParam) {
    return encodeURIComponent(filterQueryParam)
  }
  return undefined
}

export default {
  components: {
    Header,
    Main,
    SearchForm,
    TableComponent: Table,
    SortTable,
    EventListItem,
    Spinner,
    Modal,
    Button,
    Input,
    Pagination,
    FilterSelector,
  },
  name: 'calEventList',
  data() {
    return {
      view: undefined,
      user: {},
      loading: false,
      allDistricts: false,
      districtList: [],
      calEventList: [],
      pages: {},
      fields: FieldsDef,
      selected: -1,
      deleteId: -1,
      canSubmitNew: true,
      bulkImportFile: null,
      bulkImportSubmitting: false,
      showPastEvents: false,
      search: {
        query: ''
      },
      selectedSort: {
        name: '',
        descending: false
      },
      startDate: '',
      endDate: '',
      gradeList: DropdownLists.gradeList,
      searchDebounceTimer: null,
      selectedFilter: {
        eventType: [],
      },
      filterOptions: {
        eventType: Object.entries(DropdownLists.eventList).map(([code, display]) => ({ code, display })),
      },
      filterUis: [
        {
          name: 'eventType',
          text: 'Event Type',
          option: {
            value: 'code',
            display: 'display',
          },
        },
      ],
    }
  },
  methods: {
    async exportToCSV() {
      const headers = ['DistrictNumber', 'EventType', 'EventTime', 'FirstDate', 'LastDate', 'LowGrade', 'HighGrade','Building']
      const events = await this.getEvents()
      let rows = []
      for(let event of events) {
        let district
        if (event.district) {
          district = event.district.value
          const index = district.indexOf('-')
          district = district.slice(0, index)

          if (event.building) {
            district += '_' + event.building.code
          }
          else {
            district += '_' + event.district.display
          }
        }
        else {
          district = 'null'
        }
        let building = event.building ? event.building.name : event.district.name
        let lowGrade = this.gradeList[event.low_grade]
        let highGrade = this.gradeList[event.high_grade]
        if (lowGrade && lowGrade[0] == '0' && lowGrade[1] != '.') {
          lowGrade = Number(lowGrade)
        }
        if (highGrade && highGrade[0] == '0' && highGrade[1] != '.') {
          highGrade = Number(highGrade)
        }
        if (lowGrade == 'Pre-K') {
          lowGrade = 0
        }
        if (lowGrade == 'K') {
          lowGrade = 0.5
        }
        if (highGrade == 'Pre-K') {
          highGrade = 0
        }
        if (highGrade == 'K') {
          highGrade = 0.5
        }
        if (lowGrade == '12+') {
          lowGrade = 13
        }
        if (highGrade == '12+') {
          highGrade = 13
        }
        rows.push([district, event.event_type, event.time, event.event_date, event.event_date, lowGrade, highGrade, building])
      }
      rows.unshift(headers)
      let content = ''
      rows.forEach(row => {
        content += row.join(',') + '\n'
      })
      const blob = new Blob([content], {type: 'text/csv'})
      const url = URL.createObjectURL(blob)
      let anchor = this.$refs['download']
      anchor.href = url
      const timeStamp = new Date().toISOString()
      anchor.download = 'events_' + timeStamp + '.csv'
    },
    clearDateRange() {
      this.startDate = ''
      this.endDate = ''
    },
    todayIsoDate() {
      return new Date().toLocaleDateString('en-CA')
    },
    buildQueryParams(page) {
      let orderBy = 'eventDate'
      if (this.selectedSort.name) {
        const backendKey = ORDER_BY_KEY_MAP[this.selectedSort.name]
        orderBy = backendKey ? (this.selectedSort.descending ? '-' : '') + backendKey : undefined
      }
      return {
        startDate: this.startDate || (!this.showPastEvents ? this.todayIsoDate() : undefined),
        endDate: this.endDate || undefined,
        search: this.search.query || undefined,
        filterBy: createFilterQueryParam(this.selectedFilter),
        orderBy,
        page,
      }
    },
    setSelectedFilter(filterName, selectedValues) {
      this.selectedFilter[filterName] = selectedValues
      this.resetToFirstPageAndFetch()
    },
    applyDistrictTransform(events) {
      for (let calEvent of events) {
        if (calEvent.district) {
          calEvent.district = {
            value: calEvent.district.code,
            label: `${calEvent.district.code}: ${calEvent.district.name}`,
            display: calEvent.district.display_code,
            name: calEvent.district.name,
          }
        }
      }
      return events
    },
    async getEvents() {
      let allEvents = []
      let page = 1
      // eslint-disable-next-line no-constant-condition
      while (true) {
        const response = await eventListService.getAllEvents(this.buildQueryParams(page))
        if (response.status !== 200) {
          throw new Error(response.statusText)
        }
        allEvents.push(...this.applyDistrictTransform(response.data.content))
        if (!response.data.pages.next) {
          break
        }
        page = response.data.pages.next
      }
      return allEvents
    },
    toCalendarForm() {
      this.$router.push({ name: 'CalendarForm' })
    },
    onBulkImportFileSelected(event) {
      this.bulkImportFile = event.target.files[0] || null
    },
    async submitBulkImport() {
      if (!this.bulkImportFile) {
        return
      }
      this.bulkImportSubmitting = true
      try {
        await calendarFormService.postCalendarEventBulkImport(this.bulkImportFile)
        this.bulkImportFile = null
        this.$refs.bulkImportInput.value = null
        this.updateEvents()
      } catch (error) {
        console.log(error)
      } finally {
        this.bulkImportSubmitting = false
      }
    },
    typeFormatter(value) {
      return value.includes('undefined') ? '' : DropdownLists.eventList[value]
    },
    clearAllFilters() {
      events.trigger('clearFilters')
      Object.keys(this.selectedFilter).forEach(key => this.selectedFilter[key] = [])
      this.startDate = ''
      this.endDate = ''
      this.search.query = ''
      this.resetToFirstPageAndFetch()
    },
    onDelete(item) {
      this.deleteId = item.id
      this.$refs['delete-modal'].openModal()
    },
    async deleteItem(id) {
      let deleteResponse = await eventListService.deleteCalendarEvent(id)
      if (deleteResponse.status != 200) {
        this.$refs['delete-modal'].closeModal()
        throw new Error(deleteResponse.statusText)
      } else {
        this.updateEvents()
        this.$refs['delete-modal'].closeModal()
      }
      this.$router.go()
    },
    onEdit(value) {
      this.$router.push({
        name: 'CalendarForm',
        params: { filledevent: value },
      })
    },
    // async getDistricts() {
    //   let result = await districtService.getAllDistricts()
    //   for (const district of result.data) {
    //     let districtObj = {
    //       value: district.code,
    //       label: `${district.code}: ${district.name}`,
    //       display: district.display_code,
    //       name: district.name,
    //     }
    //     this.districtList.push(districtObj)
    //   } 
    // },
    async updateEvents() {
      this.user = await user.get()
      if (this.user.can('submit_calendar_event') && this.user.can('select_district')) {
        this.allDistricts = true
      }
      else {
        this.allDistricts = false
      }

      this.loading = true
      const page = parseInt(this.$route.query.page) || 1
      const eventResponse = await eventListService.getAllEvents(this.buildQueryParams(page))
      if (eventResponse.status !== 200) {
        this.loading = false
        throw new Error(eventResponse.statusText)
      }

      this.calEventList = this.applyDistrictTransform(eventResponse.data.content)
      this.pages = eventResponse.data.pages
      this.loading = false
    },
    resetToFirstPageAndFetch() {
      if (this.$route.query.page && this.$route.query.page !== '1') {
        this.$router.push({ query: { ...this.$route.query, page: '' } })
      }
      else {
        this.updateEvents()
      }
    },
    // Delays search until user stops typing
    debouncedSearch() {
      clearTimeout(this.searchDebounceTimer)
      this.searchDebounceTimer = setTimeout(() => {
        this.resetToFirstPageAndFetch()
      }, SEARCH_DEBOUNCE_MS)
    },
    checkUserCanViewPage() {
      if(!this.user.can('view_event_list')) {
        this.$router.push({
          name: 'Home'
        })
        return true
      }
    },
  },
  async mounted() {
    this.updateEvents()
    this.user = await user.get()
    this.canSubmitNew = this.user.can('view_calendar_event')
  },
  async created() {
    this.user = await user.get()
    if (this.checkUserCanViewPage()) {
      return
    }
  },
  watch: {
    selectedSort: function () {
      this.resetToFirstPageAndFetch()
    },
    'search.query': function () {
      this.debouncedSearch()
    },
    showPastEvents: function () {
      this.resetToFirstPageAndFetch()
    },
    startDate: function () {
      this.resetToFirstPageAndFetch()
    },
    endDate: function () {
      this.resetToFirstPageAndFetch()
    },
    '$route.query.page': function () {
      this.updateEvents()
    },
  }
}
</script>

<style>
#calEventList {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 20px;
}
table #main-table .flip-list-move {
  transition: transform 0.5s;
}
</style>
